import Request from "./request";

export const getLocationsList = (offset) => {
  return Request.call({
    url: `/location?per_page=100${offset ? `&offset=${offset}` : ''}`,
    method: "GET",
  });
};
